import IsSitecoreEditing from 'src/utils/isSitecoreEditing';

import styles from './_EditorHelp.module.css';

type EditorHelpProps = {
	text: string;
	indent?: boolean;
	color?: 'green' | 'blue';
};

export function EditorHelp(props: EditorHelpProps): JSX.Element {
	const isEditing = IsSitecoreEditing();

	return (
		<>
			{isEditing && (
				<code
					className={`${styles.help} ${props.indent && styles.indent} ${
						!props.color || props.color === 'green' ? styles.green : styles.blue
					}`}
				>
					{props.text}
				</code>
			)}
		</>
	);
}
